import { ENABLE_ADMIN_HELPERS, isFeatureEnabled } from '/b2b/common/helpers/FeatureFlags';

import AuthenticatedPaths from '/b2b/routing/AuthenticatedRoutes/AuthenticatedRoutes.paths';
import Component from './UserDetails.component';
import { TRIGGERS } from '/b2b/common/userpilot.triggers';
import UIActions from '/b2b/common/state/ui/UI.actions';
import UserpilotActions from '/b2b/common/state/userpilot/Userpilot.actions';
import { canManageDataMapping } from '/b2b/authentication/state/user/AuthUser.selectors';
import { connect } from 'react-redux';
import fromState from '/b2b/common/state/selectors';
import noop from 'lodash/noop';
import { signOut } from './UserDetails.commands';

const mapStateToProps = state => {
    const hasPermissionToViewOrganizations = fromState.Auth.user.hasPermission(state, {
        toPerform: 'view',
        on: AuthenticatedPaths.ORGANIZATIONS,
    });

    const customerId = fromState.Auth.customer.getId(state);
    const subscriptionId =
        (customerId &&
            fromState.DB.customer.getEntityFieldById(state, {
                id: customerId,
                field: 'subscription',
            })) ||
        '';

    const { isBusinessPlan = false, isBusinessPlusPlan = false } =
        (subscriptionId && fromState.DB.subscription.getEntityById(state, subscriptionId)) || {};

    const adminHelpersEnabled =
        ['development', 'dev'].includes(process.env.NODE_ENV) ||
        isFeatureEnabled(state, ENABLE_ADMIN_HELPERS);

    return {
        adminHelpersEnabled,
        hasPermissionToViewOrganizations,
        isBusinessPlan,
        isBusinessPlusPlan,
        shouldRenderApiKeys: canManageDataMapping(state),
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onSignOut: () => dispatch(signOut()),
        businessUpgrade: () =>
            dispatch(UserpilotActions.setUserpilotContentId(TRIGGERS.BUSINESS.id)),
        businessPlusUpgrade: () =>
            dispatch(UserpilotActions.setUserpilotContentId(TRIGGERS.BUSINESS_PLUS.id)),
        basicUpgrade: () =>
            dispatch(UserpilotActions.setUserpilotContentId(TRIGGERS.BASIC_AND_DEVELOPER.id)),
        createSnack: (message, options) => dispatch(UIActions.createSnack(message, options)),
        userPilotOrganizations: () =>
            dispatch(UserpilotActions.setUserpilotContentId(TRIGGERS.ORGANIZATIONS.id)),
    };
};

const mergeProps = (stateProps, dispatchProps, ownProps) => {
    const { hasPermissionToViewOrganizations } = stateProps;
    return {
        ...ownProps,
        ...stateProps,
        createSnack: dispatchProps.createSnack,
        onSignOut: dispatchProps.onSignOut,
        onOrganizationsClick: hasPermissionToViewOrganizations
            ? noop
            : dispatchProps.userPilotOrganizations,
    };
};

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(Component);
